import "./landing.css";

import PropTypes from "prop-types";
import background from "../static/img/system_bg.webp";
import logo from "../static/img/Hiphen_Cloverfield_logo_white.png";

// Shell shared by the three anonymous pages (login, reset request, new
// password): brand panel on the left, auth card on the right. Kept here rather
// than in components/ because it owns the landing assets and lg-* styles.
export const AuthShell = ({ title, children }) => (
  <div className="lg-split">
    <aside
      className="lg-brand"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="lg-brand-content">
        <img className="lg-logo" src={logo} alt="Cloverfield by Hiphen" />
        <p className="lg-eyebrow">Plant phenomics platform</p>
        <h1>
          Turning field imagery into <em>agronomic data</em>.
        </h1>
        <ul className="lg-points">
          <li>Multi-source imaging: drone, ground, station and satellite</li>
          <li>From raw field images to agronomic traits</li>
          <li>One data platform to explore, compare and share results</li>
        </ul>
      </div>
    </aside>

    <main className="lg-panel">
      <div className="lg-card">
        <h2 className="lg-title">{title}</h2>
        {children}
      </div>
    </main>
  </div>
);

AuthShell.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
